/* eslint-disable @typescript-eslint/no-unused-vars */
// Async Thunk for SignIn
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CognitoService from "../service/cognito";
import { userSignUpAttrs } from "../interfaces/interface";


export const signUpAction = createAsyncThunk(
  "auth/signUp",

  async (userInput: userSignUpAttrs, {rejectWithValue}) => {
    try {
      const {first_name, last_name, email, region} = userInput;
      const response = await CognitoService.signUp(first_name,last_name,email);
      return JSON.parse(JSON.stringify(response));
    }
    catch(error) {
      console.error(error);
      rejectWithValue("Couldnt create user in Cognito service")
    }
  }
);
